import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpService } from '../../service/http.service';
@Injectable({
  providedIn: 'root'
})
export class SpgService {

  constructor(private httpService: HttpService) { }

    getUser(params: any): Observable<any> {
      return this.httpService.get('master-spg', params);
    }
    saveSpg(params: any): Observable<any> {
      return this.httpService.post('save-spg', params);
    }
    getSpgById(id:any,params: any): Observable<any> {
      return this.httpService.get('master-spg/'+id, params);
    }
}
